import axiosInstance from '@/api/axiosInstance';
const state={list:[],pagination:{},reloadList:false};
const actions={
 async fetchList({commit},params){const r=await axiosInstance.get('/prospectos/list',{params}); const d=r.data.data.prospectos; commit('SET',{key:'list',data:d.list||[]}); commit('SET',{key:'pagination',data:d.pagination||{}});},
 async save({commit},data){const r=await axiosInstance.post('/prospectos/save',data); if(r.data.status) commit('SET',{key:'reloadList',data:true}); return r.data;},
 async remove({commit},id){const r=await axiosInstance.delete(`/prospectos/destroy/${id}`); if(r.data.status) commit('SET',{key:'reloadList',data:true}); return r.data;}
};
const mutations={SET(s,{key,data}){s[key]=data;}};
export default {namespaced:true,state,actions,mutations};
